export default "__VITE_PUBLIC_ASSET__a495d0b4__"